import * as adminTypes from '../actionTypes/adminTypes';
import * as actionTypes from '../actionTypes/uploadToServerActionTypes';
import createReducer from '../utils/createReducer';

const INITIAL_STATE = {
  isBulkUpload: false,
  filesToUpload: [],
  startIndex: 0
};

const reducer = {
  [adminTypes.SIGNOUT_USER_ON_AUTHENTICATION_FAIL]: (state, action) => INITIAL_STATE,
  [actionTypes.START_BULK_UPLOAD_TO_SERVER]: (state, action) => {
    const { filesToUpload } = action.payload;
    return {
      ...state,
      isBulkUpload: true,
      filesToUpload: [...state.filesToUpload, ...filesToUpload]
    };
  },
  [actionTypes.STOP_BULK_UPLOAD_TO_SERVER]: (state, action) => {
    const { startIndex } = action.payload;
    return {
      ...state,
      isBulkUpload: false,
      startIndex: startIndex
    };
  },
  [actionTypes.RESET_BULK_UPLOAD_TO_SERVER]: (state, action) => {
    return {
      ...state,
      isBulkUpload: false,
      startIndex: 0,
      filesToUpload: []
    };
  }
};

export default createReducer(INITIAL_STATE, reducer);
